import * as React from 'react';
import { cn } from '@/lib/utils';

const Certificate = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-certificate', className)}
    {...props}
  />
));
Certificate.displayName = 'Certificate';

const CertificateImg = React.forwardRef(({ className, ...props }, ref) => (
  <img
    ref={ref}
    alt="Imagem do Certificado"
    className={cn('c-certificate-img', 'mb-8 h-[132px] w-full rounded-t-[10px] object-cover', className)}
    {...props}
  />
));
CertificateImg.displayName = 'CertificateImg';

const CertificateLogo = React.forwardRef(({ className, ...props }, ref) => (
  <img
    ref={ref}
    alt="Logo do certificado"
    className={cn('c-certificate-logo', 'mb-5 w-[88px]', className)}
    {...props}
  />
));
CertificateLogo.displayName = 'CertificateLogo';

const CertificateHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-certificate-header', className)}
    {...props}
  />
));
CertificateHeader.displayName = 'CertificateHeader';

const CertificateHeaderContent = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-certificate-inner-header', 'mb-10 flex flex-wrap items-center gap-2', className)}
    {...props}
  />
));
CertificateHeaderContent.displayName = 'CertificateHeaderContent';

const CertificateTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h1
    ref={ref}
    className={cn('c-certificate-title', 'm-0 text-[32px] font-extrabold text-primary-dark', className)}
    {...props}
  />
));
CertificateTitle.displayName = 'CertificateTitle';

const CertificateIcon = React.forwardRef(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-certificate-icon', 'flex h-8 w-8 items-center justify-center rounded-full bg-primary-lightest text-primary', '[&_svg]:w-5', className)}
    {...props}
  >
    {children}
  </div>
));
CertificateIcon.displayName = 'CertificateIcon';

const CertificateBody = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-certificate-body', 'mb-10', className)}
    {...props}
  />
));
CertificateBody.displayName = 'CertificateBody';

const CertificateText = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('c-certificate-text', 'text-neutral-dark', '[&_small]:text-xs', className)}
    {...props}
  />
));
CertificateText.displayName = 'CertificateText';

const CertificateKpis = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-certificate-kpis', 'mb-2.5 mt-10 flex flex-wrap gap-3', className)}
    {...props}
  />
));
CertificateKpis.displayName = 'CertificateKpis';

const CertificateKpi = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-certificate-kpi', 'relative flex min-w-[150px] flex-grow basis-0 flex-col gap-2.5 rounded-xl border border-solid border-primary-lightest p-5', className)}
    {...props}
  />
));
CertificateKpi.displayName = 'CertificateKpi';

const CertificateKpiContent = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-certificate-kpi-content', 'flex items-center gap-2', className)}
    {...props}
  />
));
CertificateKpiContent.displayName = 'CertificateKpiContent';

const CertificateKpiValue = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('c-certificate-kpi-value', 'mb-0 text-base font-bold text-primary', className)}
    {...props}
  />
));
CertificateKpiValue.displayName = 'CertificateKpiValue';

const CertificateKpiLabel = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('c-certificate-kpi-label', 'mb-0 text-sm font-light leading-none text-[#8894AC]', className)}
    {...props}
  />
));
CertificateKpiLabel.displayName = 'CertificateKpiLabel';

const CertificateFooter = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-certificate-footer', className)}
    {...props}
  />
));
CertificateFooter.displayName = 'CertificateFooter';

export {
  Certificate,
  CertificateImg,
  CertificateLogo,
  CertificateHeader,
  CertificateHeaderContent,
  CertificateTitle,
  CertificateIcon,
  CertificateBody,
  CertificateText,
  CertificateKpis,
  CertificateKpi,
  CertificateKpiContent,
  CertificateKpiValue,
  CertificateKpiLabel,
  CertificateFooter
};
